module.exports = __webpack_public_path__ + "static/media/background_auth.794308c1.png";